import { configureStore } from '@reduxjs/toolkit';
import { productApi } from 'api/productApi';
import { healthCheckerApi } from 'api/healthCheckerApi';

const store = configureStore({
    reducer: {
        [productApi.reducerPath]: productApi.reducer,
        [healthCheckerApi.reducerPath]: healthCheckerApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            .concat(productApi.middleware)
            .concat(healthCheckerApi.middleware),
});

export default store;
